import {
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_GET_LIST_INIT,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_GET_LIST_SUCCESS,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_GET_LIST_FAILURE,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_SAVE_INIT,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_SAVE_SUCCESS,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_SAVE_FAILURE,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_DELETE_INIT,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_DELETE_PREPARE_INIT,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_DELETE_SUCCESS,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_DELETE_FAILURE,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_SET_SAVE_DATA_BY_KEY,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_SAVE_RESET,
  ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_RESET
} from './types';
import ActionsTooling from '../../../tooling/actionsTooling';

export function reset() {
  return {
    type: ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_RESET
  };
}

export function getList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_GET_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/endpointsconnectors/variableslist",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_GET_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_GET_LIST_FAILURE, error));
    }  
  };
}

export function saveEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_SAVE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/endpointsconnectors/variablessave",
        "POST",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_SAVE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_SAVE_FAILURE, error));
    }  
  };
}

export function setSaveEntityDataByKey(key, value) {
  return {
    type: ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_SET_SAVE_DATA_BY_KEY,
    key: key,
    value: value
  };
}

export function resetSaveEntity(data) {
  return {
    type: ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_SAVE_RESET,
    data: data 
  };
}

export function prepareDeleteEntity(id) {
  return {
    type: ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_DELETE_PREPARE_INIT,
    id: id
  };
}

export function deleteEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_DELETE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/endpointsconnectors/variablesdelete",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_DELETE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ENDPOINTS_CONNECTORS_VARIABLES_ADMIN_DELETE_FAILURE, error));
    }  
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/endpointsConnectorsVariablesAdmin/index.js